import React from 'react';
import { Eye, Calendar } from 'lucide-react';
import { adminApi } from './api';

export const MessagesTab = ({ contacts, onReload, onReloadStats }) => {
  const markRead = async (id) => {
    try {
      const { API_ENDPOINTS } = await import('./api');
      await adminApi.put(API_ENDPOINTS.adminContactRead(id), {});
      onReload();
      onReloadStats();
    } catch (err) {
      console.error('Mark read failed:', err);
    }
  };

  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-bold text-gray-900">Messages ({contacts.length})</h1>
      <div className="space-y-3">
        {contacts.map(m => (
          <div key={m.id} className={`bg-white rounded-xl border p-5 transition-all ${!m.read ? 'border-blue-200 bg-blue-50/30' : 'border-gray-100'}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="font-semibold text-gray-900 text-sm">{m.name}</h4>
                  {!m.read && <span className="w-2 h-2 bg-blue-500 rounded-full" />}
                </div>
                <p className="text-xs text-gray-400 mb-2">{m.email} · {m.subject}</p>
                <p className="text-sm text-gray-700 leading-relaxed">{m.message}</p>
                <p className="text-[10px] text-gray-400 mt-3 flex items-center gap-1">
                  <Calendar className="w-3 h-3" />{new Date(m.created_at).toLocaleString('fr-FR')}
                </p>
              </div>
              {!m.read && (
                <button onClick={() => markRead(m.id)} className="text-xs text-blue-600 font-medium hover:text-blue-800 whitespace-nowrap flex items-center gap-1">
                  <Eye className="w-3.5 h-3.5" />Marquer lu
                </button>
              )}
            </div>
          </div>
        ))}
        {!contacts.length && <p className="text-gray-400 text-center py-12 text-sm">Aucun message</p>}
      </div>
    </div>
  );
};
